export default __webpack_public_path__ + "assets/subscribe.f2a9.svg";